import { combineReducers } from 'redux';

import activityList from './generated/activity-list.reducer';
import cart from './cart.reducer';
import authentication from './auth.reducer';
import navigation from './navigation.reducer';
import customerSubUnitList from './generated/customer-sub-unit-list.reducer';
import supplierList from './generated/supplier-list.reducer';
import articleList from './generated/article-list.reducer';
import stockArticleList from './stock-article-list.reducer';
import brandList from './generated/brand-list.reducer';
import labelList from './generated/label-list.reducer';
import userList from './generated/user-list.reducer';
import shopUserList from './generated/shop-user-list.reducer';
import organizationList from './generated/organization-list.reducer';
import shopConfigList from './generated/shop-config-list.reducer';
import jobList from './generated/job-list.reducer';
import integrationList from './generated/integration-list.reducer';
import orderList from './generated/order-list.reducer';
import complaintList from './generated/complaint-list.reducer';
import generatedAlertList from './generated/alert-list.reducer';
import priceListList from './generated/price-list-list.reducer';
import invoiceList from './generated/invoice-list.reducer';
import supplierSalesReportList from './generated/supplier-sales-report-list.reducer';
import purchaseOrderList from './generated/purchase-order-list.reducer';
import purchaseListList from './generated/purchase-list-list.reducer';
import activityDetailsPage from './activityDetailsPage.reducer';
import priceListDetailsPage from './priceListDetails.reducer';
import orderDetailsPage from './orderDetailsPage.reducer';
import complaintDetailsPage from './complaintDetailsPage.reducer';
import supplierSalesReportDetailsPage from './supplierSalesReportDetailsPage.reducer';
import purchaseOrderDetailsPage from './purchaseOrderDetailsPage.reducer';
import purchaseListDetailsPage from './purchaseListDetailsPage.reducer';
import jobDetailsPage from './jobDetailsPage.reducer';
import integrationDetailsPage from './integrationDetailsPage.reducer';
import integrationRunsErrorsPage from './integrationRunsErrorsPage.reducer';
import articleDetailsPage from './articleDetailsPage.reducer';
import shopUserDetailsPage from './shopUserDetailsPage.reducer';
import customerSubUnitDetailsPage from './customerSubUnitDetailsPage.reducer';
import brandDetailsPage from './brandDetailsPage.reducer';
import labelDetailsPage from './labelDetailsPage.reducer';
import userDetailsPage from './userDetailsPage.reducer';
import endCustomerOrganizationList from './generated/end-customer-organization-list.reducer';
import inviteList from './generated/invite-list.reducer';
import emailList from './generated/email-list.reducer';
import validooSubscriptionList from './generated/validoo-subscription-list.reducer';
import validooCredentialList from './generated/validoo-credential-list.reducer';
import validooArticleList from './generated/validoo-article-list.reducer';
import oauthTokenList from './generated/oauth-token-list.reducer';
import outgoingMessageList from './generated/outgoing-message-list.reducer';
import outgoingMessageDetailsPage from './outgoingMessageDetailsPage.reducer';
import incomingMessageList from './generated/incoming-message-list.reducer';
import incomingMessageDetailsPage from './incomingMessageDetailsPage.reducer';
import failedActionCallList from './generated/failed-action-call-list.reducer';
import failedActionCallDetailsPage from './failedActionCallDetailsPage.reducer';
import log from './log.reducer';
import supplierCustomerList from './generated/supplier-customer-list.reducer';
import supplierCustomerDetailsPage from './supplierCustomerDetailsPage.reducer';
import alertListReducerDecorator from './alertList.decorator.reducer';
import customerSubUnitInPcsServiceList from './generated/customer-sub-unit-in-pcs-service-list.reducer';
import procurementListList from './generated/procurement-list-list.reducer';
import procurementListDetailsPage from './procurementListDetailsPage.reducer';
import procurementArticleList from './generated/procurement-article-list.reducer';
import procurementArticleDetailsPage from './procurementArticleDetailsPage.reducer';
import supplierConnectionList from './generated/supplier-connection-list.reducer';
import supplierConnectionDetailsPage from './supplierConnectionDetailsPage.reducer';
import orderFullfillmentCenterList from './generated/order-fullfillment-center-list.reducer';
import orderFullfillmentCenterDetailsPage from './orderFullfillmentCenterDetailsPage.reducer';
import organizationInOmsServiceList from './generated/organization-in-oms-service-list.reducer';
import organizationInOmsServiceDetailsPage from './organizationInOmsServiceDetailsPage.reducer';
import emailTemplateConfigList from './generated/email-template-config-list.reducer';
import emailTemplateConfigDetailsPage from './emailTemplateConfigDetailsPage.reducer';
import userInCrmList from './generated/user-in-crm-list.reducer';
import copackAgreementList from './generated/copack-agreement-list.reducer';
import orderBrokerageAgreementList from './generated/order-brokerage-agreement-list.reducer';
import entitySettlementList from './generated/entity-settlement-list.reducer';
import settlementList from './generated/settlement-list.reducer';
import settlementDetailsPage from './settlementDetailsPage.reducer';
import mappingTemplateList from './generated/mapping-template-list.reducer';
import alcoholLicenseList from './generated/alcohol-license-list.reducer';
import alcoholLicenseDetailsPage from './alcoholLicenseDetailsPage.reducer';
import categoryTreeList from './generated/category-tree-list.reducer';
import categoryTreeDetailsPage from './categoryTreeDetailsPage.reducer';
import campaignList from './generated/campaign-list.reducer';
import campaignDetailsPage from './campaignDetailsPage.reducer';
import cartDetailsPage from './cartDetailsPage.reducer';
import cartList from './generated/cart-list.reducer';
import shopConfigDetailsPage from './shopConfigDetailsPage.reducer';

import { default as errorBoundary } from 'flaivy-react/reducers/error.reducer';

const alertList = alertListReducerDecorator(generatedAlertList);

// api is added here of some reason we need to figure out.
const rootReducer = combineReducers({
  activityList,
  authentication,
  navigation,
  customerSubUnitList,
  orderList,
  complaintList,
  alertList,
  invoiceList,
  supplierSalesReportList,
  purchaseOrderList,
  supplierList,
  brandList,
  labelList,
  labelDetailsPage,
  articleList,
  stockArticleList,
  userList,
  shopUserList,
  organizationList,
  shopConfigList,
  purchaseListList,
  log,
  activityDetailsPage,
  orderDetailsPage,
  complaintDetailsPage,
  priceListDetailsPage,
  supplierSalesReportDetailsPage,
  articleDetailsPage,
  customerSubUnitDetailsPage,
  userDetailsPage,
  shopUserDetailsPage,
  purchaseOrderDetailsPage,
  purchaseListDetailsPage,
  brandDetailsPage,
  priceListList,
  cart,
  jobList,
  jobDetailsPage,
  integrationDetailsPage,
  integrationList,
  integrationRunsErrorsPage,
  emailList,
  endCustomerOrganizationList,
  validooCredentialList,
  validooArticleList,
  inviteList,
  outgoingMessageList,
  outgoingMessageDetailsPage,
  failedActionCallList,
  failedActionCallDetailsPage,
  oauthTokenList,
  errorBoundary,
  supplierCustomerList,
  supplierCustomerDetailsPage,
  customerSubUnitInPcsServiceList,
  procurementListList,
  procurementListDetailsPage,
  procurementArticleList,
  procurementArticleDetailsPage,
  supplierConnectionList,
  supplierConnectionDetailsPage,
  orderFullfillmentCenterList,
  orderFullfillmentCenterDetailsPage,
  organizationInOmsServiceList,
  organizationInOmsServiceDetailsPage,
  emailTemplateConfigList,
  emailTemplateConfigDetailsPage,
  userInCrmList,
  copackAgreementList,
  orderBrokerageAgreementList,
  entitySettlementList,
  settlementList,
  validooSubscriptionList,
  settlementDetailsPage,
  mappingTemplateList,
  incomingMessageList,
  incomingMessageDetailsPage,
  alcoholLicenseList,
  alcoholLicenseDetailsPage,
  categoryTreeList,
  categoryTreeDetailsPage,
  campaignList,
  campaignDetailsPage,
  cartList,
  cartDetailsPage,
  shopConfigDetailsPage,
});

export default rootReducer;
